import React from 'react';

import PropTypes from 'prop-types';

import { useLocale } from '@adsk/alloy-react-locale';

import TimeInput, { TimeInputProps } from './TimeInput';
import { TimePeriod, TIME_PERIODS } from '../consts';

type Props = Omit<TimeInputProps, 'value'> & {
  value?: TimePeriod;
};

const AmPmInput = React.forwardRef<HTMLInputElement, Props>(
  ({ value = TIME_PERIODS.AM, style, ...props }, ref) => {
    const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
    return (
      <TimeInput
        ref={ref}
        readOnly
        value={T.translate(value) as string}
        style={[
          {
            userSelect: 'none',
          },
          style,
        ]}
        {...props}
      />
    );
  },
);

AmPmInput.displayName = 'AmPmPicker';

AmPmInput.propTypes = {
  ...TimeInput.propTypes,
  /** The value */
  value: PropTypes.oneOf(Object.values(TIME_PERIODS)),
};

export default AmPmInput;
